import { setDisplayName, withProps, compose } from 'recompose';
import cx from 'classnames';
import { noop } from 'lodash';
import getRenderedScaleIcons from '../../utils/getRenderedScaleIcons';
import preventEvent from '../../../../utils/preventEvent';
import styles from './withScaleRatingIcons.scss';

export default compose(
  setDisplayName('withScaleRatingIcons'),
  withProps(
    ({
      ratingItemClassName,
      readOnly,
      block: { shape, size, personalLabelType, enableFillColor = false } = {},
      styling: { selectionColor } = {},
      itemListCount,
    }) => {
      const ratingIconList = getRenderedScaleIcons({
        shape,
        color: selectionColor,
        enableFillColor,
        size,
        personalLabelType,
        itemListCount,
        e2e: 'scale-item',
        fullSubstrate: {
          className: cx(ratingItemClassName, styles.fullSubstrate),
        },
        emptySubstrate: {
          className: cx(ratingItemClassName, styles.emptySubstrate),
        },
        empty: {
          className: cx(ratingItemClassName, styles.empty),
          onClick: readOnly ? preventEvent : noop,
        },
        full: {
          className: cx(ratingItemClassName, styles.full),
          onClick: readOnly ? preventEvent : noop,
        },
      });

      return {
        ratingIconList,
        sliderHandleIcon: ratingIconList.full,
      };
    },
  ),
);
